// extracted by mini-css-extract-plugin
export default {"spinner":"zEEBFCp4","rotate":"Hqc5BYxe"};